module.exports = __webpack_public_path__ + "static/img/1_1_1.3bb2b3bf.jpg";